import styled from "styled-components";
import theme from "../../../../theme";

export const PartnersSection = styled.div`
  margin: 96px 0 60px;

  @media (max-width: 426px) {
    margin: 72px 0 36px;
  }

  .logo-container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    font-size: 48px;
  }

  .logo {
    flex-grow: 1;
    flex-basis: 0;
    text-align: center;
    margin-top: auto;
    margin-bottom: auto;
  }

  .logo img {
    max-width: 100%;
    height: auto;
    margin-bottom: 36px;
  }

  @media (max-width: 768px) {
    .logo {
      flex-basis: 40%;
      max-width: 40%;
    }
  }
`;

export const Title = styled.p`
  font-family: "Inter", sans-serif;
  max-width: 800px;
  font-style: normal;
  font-size: 60px;
  line-height: 72px;
  color: ${theme.black};
  margin-bottom: 72px;

  @media (max-width: 768px) {
    font-size: 58px;
    line-height: 85px;
    text-align: center;
  }

  @media (max-width: 426px) {
    font-size: 49px;
    line-height: 62px;
  }
`;
